var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-btn',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.download()}}},[_vm._v("Download Excel")]),_vm._v(" "),_c('vue-good-table',{staticClass:"mt-3",attrs:{"columns":_vm.columns,"rows":_vm.measureTypesList,"search-options":{
            enabled: true,
            placeholder: 'Cerca misura',
        },"pagination-options":{
            enabled: true,
            position: 'bottom',
            perPageDropdown: [20, 50, 100],
            dropdownAllowAll: true,
            setCurrentPage: 1,
            jumpFirstOrLast : true,
            firstLabel : 'Prima pagina',
            lastLabel : 'Ultima pagina',
            nextLabel: 'Successiva',
            prevLabel: 'Precedente',
            rowsPerPageLabel: 'Misure per pagina',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'Tutti',
        }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd15e34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/MeasureTypes/MeasureTypesList.vue
// module id = null
// module chunks = 